import React from "react";
import PropTypes from "prop-types";

/**
 * Status indicator component
 */
const StatusIcon = ({ status }) => {
  switch (status) {
    case "completed":
      return <span className="brew-timeline__entry-status">✅</span>;
    case "active":
      return <span className="brew-timeline__entry-status">🟢</span>;
    case "warning":
      return <span className="brew-timeline__entry-status">🟠</span>;
    case "failed":
      return <span className="brew-timeline__entry-status">🔴</span>;
    default:
      return (
        <span className="brew-timeline__entry-status" style={{ opacity: 0.3 }}>
          ○
        </span>
      );
  }
};

StatusIcon.propTypes = {
  status: PropTypes.string,
};

export default StatusIcon;
